/**
 * The time zones the console offers, in ONE list for New workspace and Settings.
 *
 * Customer-portal review 2026-09-25 #61 / #160: the New workspace dialog offered nine zones and
 * Settings six, so a workspace created in Lisbon could not show its own zone in Settings, and the
 * Settings box fell back to "UTC" while the stored zone was Europe/Athens. The list covers the
 * launch markets' zones (the EU and its neighbours, where the 26 launch languages are spoken); a
 * workspace's stored zone and the browser's own zone are always added when they are not on it, so
 * the box can never show a zone other than the one stored.
 */
export const OFFERED_ZONE = [
  "Europe/Athens",
  "Europe/Nicosia",
  "Europe/Bucharest",
  "Europe/Sofia",
  "Europe/Helsinki",
  "Europe/Tallinn",
  "Europe/Riga",
  "Europe/Vilnius",
  "Europe/Istanbul",
  "Europe/Warsaw",
  "Europe/Prague",
  "Europe/Bratislava",
  "Europe/Budapest",
  "Europe/Vienna",
  "Europe/Ljubljana",
  "Europe/Zagreb",
  "Europe/Belgrade",
  "Europe/Berlin",
  "Europe/Copenhagen",
  "Europe/Stockholm",
  "Europe/Oslo",
  "Europe/Amsterdam",
  "Europe/Brussels",
  "Europe/Luxembourg",
  "Europe/Zurich",
  "Europe/Rome",
  "Europe/Malta",
  "Europe/Paris",
  "Europe/Madrid",
  "Europe/Lisbon",
  "Europe/London",
  "Europe/Dublin",
  "UTC",
] as const;

/** The browser's own zone — a measurement, offered first; `null` when the runtime cannot say. */
export function browserZone(): string | null {
  try {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return null;
  }
}

/** The offered zones, with any of `extra` (the stored zone, the browser's) that is not on it first. */
export function zoneChoice(...extra: readonly (string | null)[]): readonly string[] {
  const offered: readonly string[] = OFFERED_ZONE;
  const added = extra.filter(
    (one, index): one is string => one !== null && !offered.includes(one) && extra.indexOf(one) === index,
  );
  return [...added, ...offered];
}
